import React, { Suspense } from 'react'
import { Box, Icon, Link, Loading, Text } from '@maui/elements'
import { Drawer } from '@nautilusjs/mati-shared'
import { NewRequest } from '../new-request'
import { FreeformRequest } from '../freeform-request'
import AnalystInvestigation from '../AnalystInvestigation'
import CurrentRequests from '../CurrentRequests/CurrentRequests'
import { useEodDrawer } from '../../providers/EodDrawerContext'

export const CollapsedDrawer = () => {
  const { state, dispatch: { showCollapsedDrawer } } = useEodDrawer()

  return (
    <Box
      display={state.showCollapsedDrawer ? 'block' : 'none'}
      position='fixed'
      width='40px'
      right='0'
      top='48px'
      bottom='0'
      borderLeftWidth='3px'
      borderLeftColor='colorBorderMain'
      borderLeftStyle='solid'
      height='100%'
      backgroundColor='colorBackgroundOverlay'
      color='colorTextMain'
      onClick={() => showCollapsedDrawer(false)}
      zIndex='999999'
    >
      <Box fontSize='16px' pb='4px' mt='8px' ml='8px' mr='8px' cursor='pointer'>
        <Icon name='chevron-right-circle' style={{ transform: 'rotate(180deg)' }} />
      </Box>
      <Text
        variant='heading4'
        width='850px'
        transform='rotate(90deg)'
        transformOrigin='16px 20px'
        padding='5px'
        display='flex'
        gridGap='spaceGapMedium'
        alignItems='center'
      >
        <Icon name='messages' /> Ask an Expert | Request in Progress
      </Text>
    </Box>
  )
}

export const DrawerContent = () => {
  const { state, dispatch: { showCollapsedDrawer } } = useEodDrawer()

  const drawerTitle = state.showCurrentRequests ? `Requests (${state.caseCount || 0})` : state.requestType === 'new' ? '' : state.requestType === 'freeform' ? 'New Request' : state.requestType === 'analystInvestigation' ? 'Investigation Request' : ''

  return (
    <Drawer
      display={state.showCollapsedDrawer ? 'none' : 'block'}
      color='colorTextMain'
      borderLeft='1px'
      borderLeftColor='colorBorderMain'
      borderLeftStyle='solid'
      zIndex='999999'
    >
      <Drawer.Header>
        <Drawer.TitleIcon name='messages' />
        <Box flex='1'>
          <Drawer.Title>Ask an Expert {drawerTitle && `| ${drawerTitle}`}</Drawer.Title>
        </Box>
        <Link
          variant="primary"
          fontWeight="fontWeightBold"
          textDecoration="none"
          _hover={{ textDecoration: 'none' }}
          display="flex"
          alignItems="center"
          onClick={() => showCollapsedDrawer(true)}
        >
          Collapse <Icon name='chevron-right-circle' ml={5} />
        </Link>
      </Drawer.Header>
      <Suspense fallback={<Loading />}>
        <Drawer.Body height="100%">
          <Box overflowY='scroll' minHeight='1010px' p='4px'>
            { !state.showCurrentRequests && (
              (state.requestType === 'new' && <NewRequest />) ||
              (state.requestType === 'freeform' && <FreeformRequest />) ||
              (state.requestType === 'analystInvestigation' && <AnalystInvestigation />))
            }
            { state.showCurrentRequests && <CurrentRequests /> }
          </Box>
        </Drawer.Body>
      </Suspense>
    </Drawer>
  )
}
